import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { useDispatch, useSelector } from "react-redux";
import CustomSelect from "../../../../components/Select/Select";
import { fetchAppointmentTypes } from "../../../../redux/reducers/appointmentTypeSlice";
import { minutesToHours } from "../../../../util/function";
import "./Type.css";

const defaultDropObj = { name: 'Overall', value: 'Overall' }

function AppointmentFunnel() {
  const dispatch = useDispatch();
  const { loading, appointmentFunnel } =
    useSelector((state) => state.appointmentTypes);
  const [funnelTypes, setFunnelTypes] = useState([]);
  const [donutSeries, setDonutSeries] = useState([]);
  const [dropList, setDropList] = useState([defaultDropObj]);
  const [selectedDrop, setSelectedDrop] = useState(defaultDropObj);

  useEffect(() => {
    dispatch(fetchAppointmentTypes());
  }, [dispatch]);

  useEffect(() => {
    if (loading || !appointmentFunnel) return
    const sortedList = [...(appointmentFunnel?.overall?.stages ?? [])]?.sort((a, b) => b?.count - a?.count)
    const reqList = sortedList?.map((li) => li?.stage)
    setFunnelTypes(reqList);
    setDonutSeries(sortedList?.map((li) => li?.count ?? 0));
    const addDrops = appointmentFunnel?.byChannel?.map((li) => {
      const reqName = (li?.label ?? '')?.charAt(0)?.toUpperCase() + (li?.label ?? '')?.slice(1);
      return { name: reqName, value: (li?.label ?? "") }
    })
    setDropList([defaultDropObj, ...(addDrops ?? [])]);
  }, [appointmentFunnel]);


  const funnelOptions = {
    chart: {
      type: "bar",
      toolbar: { show: false },
      height: 350
    },
    plotOptions: {
      bar: {
        borderRadius: 0,
        horizontal: true,
        barHeight: "80%",
        isFunnel: true,
        distributed: true
      }
    },
    dataLabels: {
      enabled: true,
      formatter: function (val, opts) {
        const label = funnelTypes[opts.dataPointIndex];
        return label;
      },
      style: {
        fontSize: '12px',
        fontWeight: 600,
        colors: ['#fff']
      },
      offsetX: 0,
      offsetY: 0,
    },
    xaxis: {
      categories: funnelTypes,
      labels: {
        show: false
      }
    },
    yaxis: {
      labels: {
        show: false
      }
    },
    colors: ["#1D4ED8",
      "#9333EA",
      "#8B5CF6",
      "#06B6D4",
      "#A78BFA",
    ],
    legend: { show: false },
    tooltip: {
      custom: function ({ series, seriesIndex, dataPointIndex, w }) {
        const label = funnelTypes?.[dataPointIndex]
        const reqData = [...(appointmentFunnel?.overall?.stages ?? [])]?.sort((a, b) => b?.count - a?.count)?.[dataPointIndex]
        const txt = `Avg delay: ${minutesToHours(reqData?.avgTimeInStage)}`
        return (
          '<div class="apexcharts-tooltip-title" style="font-family: Helvetica, Arial, sans-serif; font-size: 12px; background-color: #EBEBEB; color: #000; padding: 8px; margin: 0;">' +
          label +
          '<span class="apexcharts-tooltip-marker" style="background-color: ' +
          w.globals.colors[dataPointIndex] +
          '; margin-left: 5px;"></span>' +
          "</div>" +
          '<div class="apexcharts-tooltip-series-group" style="order: 1; display: flex; background-color: #fff; padding: 8px;">' +
          '<div class="apexcharts-tooltip-text" style="font-family: Helvetica, Arial, sans-serif; font-size: 12px; color: #000;">' +
          '<div class="apexcharts-tooltip-y-group">' +
          '<span class="apexcharts-tooltip-text-y-label">' +
          'Conversion %:' +
          "</span>" +
          '<span class="apexcharts-tooltip-text-y-value">' +
          reqData?.conversionFromPreviousFormatted +
          "</span>" +
          "</div>" +
          '<div class="apexcharts-tooltip-y-group">' +
          '<span class="apexcharts-tooltip-text-y-value">' +
          txt +
          "</span>" +
          "</div>" +
          "</div>" +
          "</div>"
        );
      },
    },
  };

  const onChangeFilter = (value) => {
    if (!value?.value) return
    setSelectedDrop(value)
    if (value?.value === 'Overall') {
      const sortedList = [...(appointmentFunnel?.overall?.stages ?? [])]?.sort((a, b) => b?.count - a?.count)
      const reqList = sortedList?.map((li) => li?.stage)
      setFunnelTypes(reqList);
      setDonutSeries(sortedList?.map((li) => li?.count ?? 0));
    }
    if (value?.value !== 'Overall') {
      const reqData = appointmentFunnel?.byChannel?.find((li) => li?.label?.toLowerCase() === value?.value?.toLowerCase())
      const sortedList = [...(reqData?.stages ?? [])]?.sort((a, b) => b?.count - a?.count)
      const reqList = sortedList?.map((li) => li?.stage)
      setFunnelTypes(reqList);
      setDonutSeries(sortedList?.map((li) => li?.count ?? 0));
    }
  }


  return (
    <div className="dashboard-container" >
      {/* Type of Appointment (Donut Chart) */}
      <div className="donut-box-no-width">
        <div className="donut-header">
          <h3>Appointment Funnel</h3>
          <div className="flex1-end">
            <div className="w20Per">
              <CustomSelect list={dropList} value={selectedDrop} search handleChange={(e, value) => {
                onChangeFilter(value)
              }} />
            </div>
          </div>
          {/* <select>
            <option>Feb</option>
            <option>Mar</option>
            <option>Apr</option>
          </select> */}
        </div>
        {donutSeries?.length > 0 ? (
          <Chart
            options={funnelOptions}
            series={[{ name: "Appointments", data: donutSeries }]}
            type="bar"
            height={350}
          />
        ) : (
          <p>No data available for Appointment Funnel.</p>
        )}
      </div>
    </div>
  );
}

export default AppointmentFunnel;
